module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BA-04c596821bb3e8f703ccd22af222c969.png";